import { authHeader } from "../../../../auth";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
    data() {
        return {
            editor: ClassicEditor,
            editorConfig: {
                ckfinder: {
                    // The URL of your file repository.
                    uploadUrl: this.$serverURL + this.$api.editor.uploadFileURL,
                }
            },
            setURL: this.$serverURL + this.$api.brandDetailsPage.addCustomBrand,

            logo: "",
            previewLogo: "",

            banner: "",
            previewBanner: "",

            brand: [],
            brandList: [],
        }

    },
    async created() {
        document.title = "Dispo - Add Custom Brand";
        await this.getBrandList();
    },
    methods: {
        uploadBannerImage: function (event) {
            this.banner = event.target.files[0];
            let input = this.$refs.bannerInput;
            let file = input.files
            if (file && file[0]) {
                let reader = new FileReader
                reader.onload = e => {
                    this.previewBanner = e.target.result
                }
                reader.readAsDataURL(file[0])
            }
        },
        uploadLogoImage: function (event) {
            this.logo = event.target.files[0];
            let input = this.$refs.logoInput;
            let file = input.files
            if (file && file[0]) {
                let reader = new FileReader
                reader.onload = e => {
                    this.previewLogo = e.target.result
                }
                reader.readAsDataURL(file[0])
            }
        },
        checkValidation: function () {
            if (!(Object.keys(this.brand).length)) {
                this.$swal.fire({
                    icon: "error",
                    text: "Please select brand!"
                });
                return false;
            }
            return true;
        },
        addBrand: async function () {
            if (this.checkValidation()) {
                try {
                    this.$swal.showLoading();
                    let formData = new FormData();
                    formData.append("brandId", this.brand.value.brandId);
                    formData.append("brandName", this.brand.value.brandName);
                    formData.append("retailerId", this.brand.value.retailerId);
                    formData.append("retailerName", this.brand.value.retailerName);
                    formData.append("banner", this.banner);
                    formData.append("logo", this.logo);

                    let config = {
                        method: 'POST',
                        url: this.setURL,
                        data: formData,
                        headers: {
                            ...authHeader(),
                            "Content-Type": "multipart/form-data",
                        }
                    };
                    await this.$axios(config).then((response) => {
                        if (response.status == 201) {
                            this.$swal.fire({
                                toast: true,
                                position: 'top-end',
                                text: response.data.message,
                                icon: "success",
                                showConfirmButton: false,
                                timer: 3000,
                                animation: false,
                                timerProgressBar: true,
                                didOpen: (toast) => {
                                    toast.addEventListener('mouseenter', this.$swal.stopTimer)
                                    toast.addEventListener('mouseleave', this.$swal.resumeTimer)
                                }
                            });
                        }
                        this.brand = [];
                        this.logo = "";
                        this.banner = "";
                        this.previewLogo = "";
                        this.previewBanner = "";
                        this.$refs.logoInput = null;
                        this.$refs.bannerInput = null;
                        this.$router.push("/brand-details-page/brand");
                    }).catch(error => {
                        this.$swal.fire({
                            icon: "error",
                            text: error.response.data.message
                        });
                    });
                } catch (error) {
                    this.$swal.hideLoading();
                    this.$swal.fire({
                        icon: "error",
                        text: "Something went wrong. Please try again! " + error
                    });
                }
            }
        },
        getBrandList: async function () {
            const url = this.$serverURL + this.$api.brandDetailsPage.getAllBrands;
            const config = {
                method: "GET",
                url: url,
                headers: {
                    ...authHeader()
                }
            }
            await this.$axios(config).then(async (response) => {
                if (response.status == 200) {
                    this.brandList = response.data.data.map((el) => {
                        return { value: el, label: `${el.brandName} (${el.retailerName})` };
                    });
                }
                else {
                    this.$swal.fire({
                        icon: "error",
                        text: "Failed! please try again."
                    });
                }
            }).catch(error => {
                console.log(error);
                this.$swal.fire({
                    icon: "error",
                    text: "Failed! please try again." + error
                });
            });
        }
    },
}